export const environment = {
  production: true,
  apiLink: 'https://api.configurator.pca.gr/api',
  imageLink: 'https://api.configurator.pca.gr/image/'
  //apiLink: 'http://configurator_backend_laravel.test/api',
  //imageLink: 'http://configurator_backend_laravel.test/image/'
};
